import * as React from "react";
const SvgMicOff20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M10 0c1.605 0 3.033.756 3.948 1.931l-1.433 1.433A3 3 0 0 0 7 5v3.879l-1.734 1.734A4.993 4.993 0 0 1 5 9V5a5 5 0 0 1 5-5ZM7.883 13.531l-.744.744A6 6 0 0 0 16 9V8h2v1a8.001 8.001 0 0 1-7 7.938V18h3v2H6v-2h3v-1.062a7.952 7.952 0 0 1-3.32-1.204l-3.973 3.973-1.414-1.414 18-18 1.414 1.414L15 6.414V9a5 5 0 0 1-7.117 4.531ZM13 8.414l-3.538 3.538A3 3 0 0 0 13 9v-.586ZM4 9c0 .848.176 1.655.493 2.386l-1.492 1.492a7.964 7.964 0 0 1-1-3.878V8h2v1Z",
      clipRule: "evenodd"
    })
  );
export default SvgMicOff20Px;
